<template lang="html">

  <section class="editorial_placeholders">
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <b-collapse id="editorial_placeholders_filters" class="mt-2 ml-4 mr-4">
            <b-card>
              <p class="card-text">Filters</p>
              <div class="row">
                <div class="col-lg-3">Code:</div><input type="text" class="col-lg-3" v-model="codeFilter" placeholder="Code"/>
                <div class="col-lg-3">Label:</div><input type="text" class="col-lg-3" v-model="labelFilter" placeholder="Label"/>
              </div>
              <b-button variant="primary" v-b-toggle.editorial_placeholders_filters @click="search()"><i class="mdi mdi-magnify"></i>Search</b-button>
            </b-card>
          </b-collapse>
          <div class="col-lg-12 card-body row">
            <div class="col-lg-3">
              <h4 class="card-title">Editorial Placeholders</h4>
              <p class="card-description">
                {{curModel}} - {{getCurModel7DigitsCode}} - {{getLanguageLabel}}
              </p>
            </div>
            <div class="col-lg-4">
             
              <div class="col-lg-12 row">
                <b-pagination
                  align="fill"
                  limit="4"
                  v-model="currentPage"
                  :total-rows="(items && items.length) ? items.length : 0"
                  :per-page="perPage"
                  first-text="<<"
                  prev-text="<"
                  next-text=">"
                  last-text=">>"
                  ellipsisText="..."
                  aria-controls="table"
                  class="col-lg-9"
                ></b-pagination>
                <b-form-select id="perPage-dd" v-model="perPage" class="col-lg-3">
                  <b-form-select-option value="5">5</b-form-select-option>
                  <b-form-select-option value="10">10</b-form-select-option>
                  <b-form-select-option value="20">20</b-form-select-option>
                  <b-form-select-option value="50">50</b-form-select-option>
                  <b-form-select-option value="100">100</b-form-select-option>
                </b-form-select>
              </div>
            </div>
            <div class="col-lg-5">
              <span class="float-right">
                <b-button variant="primary mr-1" @click="refreshTable"><i class="mdi mdi-refresh"></i>Refresh Table</b-button>
                <b-button variant="primary mr-1" v-b-toggle.editorial_placeholders_filters v-if="false"><i class="mdi mdi-filter"></i></b-button>
                <b-button variant="primary mr-1" v-b-modal.modal-new-int-lab @click="btnNew"><i class="mdi mdi-plus"></i>New</b-button>
                <b-button variant="primary mr-1" v-b-modal.modal-export><i class="mdi mdi-file-export"></i>Export</b-button>
                <b-button variant="primary" v-b-modal.modal-import><i class="mdi mdi-file-import"></i>Import</b-button>
              </span>
            </div>
            <b-table ref="editorial_placeholders_tab"
              id="table" 
              striped 
              hover 
              responsive 
              :items="items" 
              :fields="fields"
              :per-page="perPage"
              :current-page="currentPage"
              primary-key="id"
              no-local-sorting
              no-provider-paging
              sort-icon-left
            >
              <!-- A custom formatted column -->
              <template v-slot:cell(buttons)="data" lang="html">
                <b-row>
                  <b-button class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-modal.modal-edit @click="curItem=data.item">
                    <i class="mdi mdi-pencil"></i>
                  </b-button>
                  <b-button class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="danger" @click="deleteItem(data.item)">
                    <i class="mdi mdi-delete"></i>
                  </b-button>
                </b-row>
              </template>
            </b-table>

            <b-modal id="modal-edit" title="Edit" v-if="curItem" size="lg" header-bg-variant="primary" header-text-variant="light" centered>
              <b-container fluid>
                <b-row>
                  <div class="col-lg-3">Code*:</div><input type="text" class="col-lg-3" placeholder="Code" v-model="curItem.code" disabled/>
                  <div class="col-lg-3">Country*:</div><input type="text" class="col-lg-3" placeholder="Label" v-model="curItem.country" disabled/>
                </b-row>
                <hr>
                 <b-row>    
                   <div class="col-lg-3">Language :   </div>               
                  <div class="col-lg-2">{{curItem.language.description}}</div>               
                  <div class="col-lg-12"><hr /></div>
                </b-row>
                <b-row>
                  <div class="col-lg-3">Content*:</div>
                  <textarea class="col-lg-9" placeholder="Content" v-model="curItem.content"></textarea>
                </b-row>
              </b-container>
              <template v-slot:modal-footer="{ cancel, ok }" lang="html">
                <fragment><!-- serve semplicemente ad evitare di avere l'errore per cui Vue si lamenta che un template deve avere un solo figlio -->
                  <b-button variant="secondary" @click="cancel()">
                    Annulla
                  </b-button>
                  <b-button variant="primary" @click="saveCurItem(curItem)">
                    Salva
                  </b-button>
                </fragment>
              </template>
            </b-modal>
             <b-modal id="modal-new-int-lab" title="New Editorial Palceholder"  size="lg" header-bg-variant="primary" header-text-variant="light" centered>
              <b-container fluid>
                <hr>
                  <b-row>
                  <div class="col-lg-3">Code*:</div><input type="text" class="col-lg-3" placeholder="Code" v-model="newItem.code" />
                  <div class="col-lg-3">Country*:</div>
                   <b-form-select id="country-dd" v-model="newItem.country" class="col-lg-3">
                    <b-form-select-option v-for = "cn in getCountries" :value="cn.id">{{cn.description}}</b-form-select-option>
                  </b-form-select>
                </b-row>
                <hr>
                <b-row>
                  <div class="col-lg-3">Language :   </div> <div class="col-lg-3">{{getCurLanguageObj.text}}</div>
                  <div class="col-lg-3">Model:</div> <div class="col-lg-2">{{getCurModel}}</div> 
                </b-row>
                   <b-row>
                  <div class="col-lg-12"><hr /></div>
                </b-row>
                <b-row>
                  <div class="col-lg-3">Content*:</div>
                  <textarea class="col-lg-9" placeholder="Content" v-model="newItem.content"></textarea>
                </b-row>
              </b-container>
              <template v-slot:modal-footer="{ cancel, ok }" lang="html">
                <fragment><!-- serve semplicemente ad evitare di avere l'errore per cui Vue si lamenta che un template deve avere un solo figlio -->
                  <b-button variant="secondary" @click="cancel()">
                    Annulla
                  </b-button>
                  <b-button variant="primary" @click="createItem()">
                    Salva
                  </b-button>
                </fragment>
              </template>
            </b-modal>
            <b-modal id="modal-export" title="Export"  size="lg" header-bg-variant="primary" header-text-variant="light" centered>
              <b-container fluid>
                <b-row>
                  <div class="col-lg-3">Scope*:</div>
                  <div>
                    <b-form-select v-model="selected" :options="options"></b-form-select>
                  </div>
                  <div class="col-lg-3">Languages:</div>
                  <b-form-select id="languages" v-model="newItem.languageToExport" class="col-lg-3">
                    <b-form-select-option value="ALL">All languages</b-form-select-option>
                    <b-form-select-option v-for = "lg in languages" :value="lg.value">{{lg.value}}</b-form-select-option>
                  </b-form-select>
                </b-row>
              </b-container>
              <template v-slot:modal-footer="{ cancel, ok }" lang="html">
                <fragment><!-- serve semplicemente ad evitare di avere l'errore per cui Vue si lamenta che un template deve avere un solo figlio -->
                  <b-button variant="secondary" @click="cancel()">
                    Annulla
                  </b-button>
                  <b-button variant="primary" @click="newItem.scope=selected; urlExport='toCsv'; export_Xlsx_Csv(newItem)">
                    Export csv
                  </b-button>
                  <b-button variant="primary" @click="newItem.scope=selected; urlExport='toXlsx'; export_Xlsx_Csv(newItem)">
                    Export xlsx
                  </b-button>
                </fragment>
              </template>
            </b-modal>
            <b-modal id="modal-import" title="Upload File"  size="lg" header-bg-variant="primary" header-text-variant="light" centered>
              <div class='modal-body'>
                <!-- Form -->
                <form method='post' action='' enctype='multipart/form-data'>
                <div class='custom-file mb-3'>
                <input type='file' class='custom-file-input' id='file-input' name='filename' @change="changeFileName()">
                <label class='custom-file-label' for='file-input'>{{fileName}}</label>
                </div>
                <br>
                </form>
                <!-- Preview-->
                <div id='preview'></div>
              </div>
              <template v-slot:modal-footer="{ cancel, ok }" lang="html">
                <fragment><!-- serve semplicemente ad evitare di avere l'errore per cui Vue si lamenta che un template deve avere un solo figlio -->
                  <b-button variant="secondary" @click="cancel()">
                    Annulla
                  </b-button>
                  <b-button variant="primary" @click="uploadFile()">
                    Upload
                  </b-button>
                </fragment>
              </template>
            </b-modal>
            
          </div>
        </div>
      </div>
    </div>
  </section>

</template>
<style >
  .table td, .table th {
    max-width: 20vw;
}

li.nav-item.active > a {
  color: #fff!important;
    text-shadow: 2px 2px 4px rgba(100,100,100,0.5);
}
</style>
<script lang="js">
import { mapState, mapActions, mapGetters } from "vuex";
 const FileDownload = require('js-file-download');
export default {
  name: 'editorial_placeholders',
  methods: {
    export_Xlsx_Csv(data){
      this.setSpinnerStatus(true);
      this.axios
      .get('/ccb/auth/fe/editorialPlaceholders/'+this.urlExport+'?scope='+data.scope+'&languageToExport='+data.languageToExport,  {
        responseType: 'blob',
        ...this.authHeader})
      .then(response => {
        if(response.status == 200) {            
          this.$bvModal.msgBoxOk(response.data.message, {
            okVariant: 'success',
            hideHeaderClose: false,
            centered: true,
          })
          var disposition = response.headers['content-disposition'];
          var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          var matches = filenameRegex.exec(disposition);
          var filename = matches[1].replace(/['"]/g, '');
          FileDownload(response.data, filename);
        }
      })
      .catch(error => {
        this.$bvModal.msgBoxOk(error.message, {
          okVariant: 'danger',
          hideHeaderClose: false,
          centered: true
        })
      }).finally(e=>{
        this.setSpinnerStatus(false);
        this.$bvModal.hide('modal-export');
      })
    },
    uploadFile(){
      let file=document.querySelector('#file-input').files[0];   
      let formData = new FormData();
      formData.append("file", file );
      formData.append("filename", file.name );
      this.setSpinnerStatus(true);
      this.axios.post("/ccb/auth/fe/editorialPlaceholders/fromCsv", formData ,  this.authHeader)      
      .then((response) => {
        var result="";
        response.data.forEach(element => {
          result+=element+" \n \n";
        });
          window.datas = result;         
          const messageNodes = this.$createElement(
              'pre',
              {
                domProps: { innerHTML: result }
              }
            )
          this.$bvModal.msgBoxOk([messageNodes], {
              okVariant: 'success',
              hideHeaderClose: false,
              centered: true,
              size: 'xl'
            }).then(value => {
                    this.refreshTable();     
              })       
        })
      .catch(error => {
        this.$bvModal.msgBoxOk(error.message, {
          okVariant: 'danger',
          hideHeaderClose: false,
          centered: true
        })
      }).finally(e=>{
        this.setSpinnerStatus(false);
        this.$bvModal.hide('modal-import');
      })
    },
    changeFileName(){
      if(document.querySelector('#file-input').files[0] && document.querySelector('#file-input').files[0].name) {
        this.fileName = document.querySelector('#file-input').files[0].name;
      } else 
      {
        this.fileName = '';
      }

    },
    deleteItem(item) {
      this.$bvModal.msgBoxConfirm('Vuoi veramente cancellare '+item.code+'?', {
        title: 'Elimina',
        okVariant: 'danger',
        okTitle: 'Elimina',
        cancelTitle: 'Annulla',
        hideHeaderClose: false,
        centered: true
      })
      .then(value => {
        if (value){
            this.setSpinnerStatus(true);
            this.axios
            .delete('/ccb/auth/fe/editorialPlaceholders/' + item.id ,this.authHeader)
            .then(response => {   
              this.setSpinnerStatus(false);    
              this.$bvModal.msgBoxOk(response.data.message, {
                okVariant: 'success',
                hideHeaderClose: false,
                centered: true
              })
              .then(value => {
                this.refreshTable();
                this.curItem=null;
              })
          })
          .catch(error => {
          this.$bvModal.msgBoxOk(error.message, {
            okVariant: 'danger',
            hideHeaderClose: false,
            centered: true
          })
          }).finally(e=>{
            this.setSpinnerStatus(false);
          })    

        }
      })
     
    },
    saveCurItem(curItem) {
      this.setSpinnerStatus(true);       
      this.axios
        .put('/ccb/auth/fe/editorialPlaceholders/' + curItem.id, curItem ,this.authHeader)
         .then(response => {
            if(response.status == 200) {            
            this.$bvModal.msgBoxOk(response.data.message, {
              okVariant: 'success',
              hideHeaderClose: false,
              centered: true
            })
          .then(value => {
            this.refreshTable();
          })
          }
        })
        .catch(error => {
          this.$bvModal.msgBoxOk(error.message, {
            okVariant: 'danger',
            hideHeaderClose: false,
            centered: true
          })
        }).finally(e=>{
          this.setSpinnerStatus(false);
          this.$bvModal.hide('modal-edit');
        })
    },
    createItem() {
    var intLabObj = this.newItem     
    if((intLabObj.code==null || intLabObj.country==null || intLabObj.content==null ) || (intLabObj.code.trim()=="" || intLabObj.content.trim()=="" )) {
       this.$bvModal.msgBoxOk("Inserisci tutti i campi obbligatori", {
        okVariant: 'danger',
        hideHeaderClose: false,
        centered: true
      })
    }else{
      this.setSpinnerStatus(true);    
      intLabObj.language = {id: this.getCurLanguageObj.id}
      intLabObj.model = {modelcode: this.getCurModel};
      this.axios
        .post('/ccb/auth/fe/editorialPlaceholders', intLabObj, this.authHeader)
          .then(response => {
            if(response.status == 200) {
              this.$bvModal.msgBoxOk(response.data.message, {
              okVariant: 'success',
              hideHeaderClose: true,
              centered: true
            })
            this.search();
            }
          })
          .catch(error => {
            this.$bvModal.msgBoxOk(error.message, {
              okVariant: 'danger',
              hideHeaderClose: false,
              centered: true
            })
          }).finally(e=>{
            this.setSpinnerStatus(false);
            this.$bvModal.hide('modal-new-int-lab');
          })
      }
    },
    search() {
      this.setSpinnerStatus(true);  
      this.setLastSearch(this.search)
      var params = {
            language: this.getCurLanguage, modelName: this.getCurModel,
            page: this.currentPage - 1, size: this.perPage, sortBy: this.sortBy, sortDesc: this.sortDesc, 
            label: this.labelFilter, code: this.codeFilter, modelEnableRegexp: this. modelEnableRegexpFilter, 
            modelDisableRegexp: this. modelDisableRegexpFilter,  content: this.contentFilter }
      
      this.axios
      .get('/ccb/auth/fe/editorialPlaceholders/findAllByParams' ,  {
        params: params,
        ...this.authHeader}          
          )
          .then((response) => {
          this.setSpinnerStatus(false);   
          this.setEditorialPlaceholders(response.data.content)                  
          });
    },
    btnNew() {
    },
    refreshTable() {
      this.search();
    },
    ...mapActions([
      'setCurApp',
      'setLastSearch',
      'setSpinnerStatus',
      'setEditorialPlaceholders',
      'setCurLabelGroup'
      
    ])
  },
  props: ['action'],
  data () {
    return {
      urlExport:' ',
      fileName:'',
      selected: 'VERS',
      options: [
        { value: 'VERS', text: 'For versioning' },
        { value: 'MKTG', text: 'For marketing' },
      ],
      currentPage:1,
      perPage:10,
      sortBy:'code',
      sortDesc: false,
      curItem:null,
      newItem : {
        code: null,
        content: null,
        country: null,
        id: null,
        language: null,
        model:null,
        scope:null, 
        languageToExport:null
      },
      fields: [
        {
          key: 'code',
          //label: 'Code',
          sortable: false
        },
        {
          key: 'country',
          label: 'country',
          sortable: false
        },
        {
          key: 'language.description',
          label: 'language',
          sortable: false
        },       
        {
          key: 'content',
          label: 'content',
          sortable: false
        },
        {
          key: 'buttons',
          label: '',
          sortable: false
        }
      ],
      labelFilter: '',
      codeFilter: '',
      modelEnableRegexpFIlter: '',
      modelDisableRegexpFilter: '',
      contentFilter: ''
    }
  },
  computed: {
    items () {
      return (this.getEditorialPlaceholders && this.getEditorialPlaceholders.length) ? this.getEditorialPlaceholders : [];
    },
    ...mapState([
      'curLanguage',
      'curModel',      
      'languages',
      'models'
    ]),
    ...mapGetters([
      'getCurModel7DigitsCode',
      'getLanguageLabel',
      'getEditorialPlaceholders',
      'getLabelGroupList',
      'authHeader',
      'getCurLabelGroup',
      'getCurLanguage',
      'getCurLanguageObj',
      'getCurModel',
      'getCountries'
    ])
  },
   watch: {
     $route (to,from){
       this.routerParams = to;
       if(to.query.activeGroup && to.query.activeGroup !=null){
          this.setCurLabelGroup(to.query.activeGroup);        
        }
       if(to.query.action && to.query.action === 'search'){
        this.search();        
       }
     },
    items (oldValue, newValue) {
      console.log(this.$refs)
      this.$refs.editorial_placeholders_tab.refresh();
    }
  },
  mounted() {
    window.scoper = this
     if(this.$route.query.activeGroup && this.$route.query.activeGroup !=null){
          this.setCurLabelGroup(this.$route.query.activeGroup);        
        }
       if(this.$route.query.action && this.$route.query.action === 'search'){
         //alert('search')
        this.search();        
       }
    this.setCurApp('ccadm');
  },
  created() {
    this.newItem.languageToExport = "ALL";
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/scss/_variables.scss";
.collapse {
  border: 1px solid $gray-lightest;
  border-radius: 0.25rem;
}
</style>
